import React from "react";
import { Link , useNavigate } from "react-router-dom";
import { dataCards } from "../../data/data";

const Classification = () => {
  return (
    <div className=" tw-py-14">
      <div className="tw-w-[80%] tw-mx-auto tw-mt-4"
       data-aos="fade-left"
       data-aos-duration="700"
       >
       <span className="tw-text-second-zain tw-tracking-wide tw-font-bold tw-text-xl md:tw-text-lg sm:tw-text-sm tw-py-3 tw-px-2 tw-pr-4 tw-rounded-sm tw-shadow-sm tw-border-r-2 tw-border-second-zain">
         التصنيفات
        </span>
        </div>
        <div className="tw-container tw-py-6 tw-mb-16 tw-mt-2 tw-flex tw-justify-center tw-items-center"> 
      <div className="tw-grid tw-grid-cols-3 md:tw-grid-cols-1 tw-gap-2 tw-mt-10 tw-py-2 tw-w-[80%]">
        {dataCards.map((item, index) => (
          <Link to={item.links}  key={index}
          data-aos="fade-left"
            data-aos-duration="1000">
          <div
            
            className="tw-flex tw-flex-col tw-items-center tw-bg-white tw-border tw-border-gray-50 tw-rounded-xl tw-py-8 tw-px-2 tw-shadow-sm hover:tw-shadow-xl hover:tw-shadow-gray-200 tw-border-r-2 tw-border-b-second-zain tw-cursor-pointer  tw-duration-500 "
          >
            <div className="tw-flex tw-justify-center tw-items-center">
              <span className=" tw-text-2xl sm:tw-text-xl tw-shadow-md tw-rounded-xl tw-p-4 tw-m-6 tw-text-second-zain">{item.icon}</span>
            </div>
            <div className="tw-font-semibold tw-text-2xl sm:tw-text-xl tw-text-second-zain tw-mt-4">
              <h2>{item.title}</h2>
            </div>
            <div className="tw-text-sm tw-m-3 tw-mt-4 tw-text-gray-500 tw-text-center">
              <p>{item.body}</p>
            </div>
          </div>
          </Link>
        ))}
      </div>
    </div>
    </div>
  );
};

export default Classification;
